import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitEmbedRoute: InvariantJiraRoute = {
	name: 'software-form-submit-embed',
	path: '/jira/software/projects/:projectKey/form/:formId/embed',
	exact: true,
};
